module.exports = __webpack_public_path__ + "static/media/star.876c918c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/star.svg
// module id = 554
// module chunks = 0